<template>
  <!-- 热门课程 -->
  <div class="hod-kecheng">
    <div class="hod-kecheng_div">
      <div class="home-title">
        <img src="@/assets/left.png" alt="">
        <div class="home-title-main">
          <p> 美课教育趣味多元化学习方式</p>
          <p> 课程多样多项发展</p>
        </div>
        <img src="@/assets/right.png" alt="">
      </div>
      <div class="kecheng_box">
        <div class="kecheng_box_item" v-for="(item,index) in courseDatas" :key="index" @click="showCourse(item.id)">
          <img :src="item.thumb" v-bind:alt="item.title">
        </div>
      </div>
      <button class="kecheng-but" @click="more()">
        <span>查看更多热门课程</span>
      </button>
    </div>
  </div>
</template>
<script>
  // import slider components
  export default {
    name: 'popular',
    data() {
      return {
        courseDatas: {}
      }
    },
    created() {
      this.getCourseData()
    },
    methods: {
      showCourse(id) {
        this.$router.push({
          path: "/curriculumDetail",
          query: {
            id: id
          }
        })
      },
      more() {
        this.$router.push({
          path: "/curriculum"
        })
      },
      getCourseData() {
        this.$axios({
          method: 'post',
          url: '/api/course/listData',
          data: {
            page: 1,
            limit: 8,
            type:1
          },
          headers: {
            token: this.$cookieStore.getCookie('token')
          }
        }).then(res => {
          this.courseDatas = res.data.data.data
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
</script>
<style scoped>
  /********** 热门课程 **********/
  .hod-kecheng {
    background-color: rgb(255, 255, 255);
    width: 100%;
    height: auto;
    min-height: 800px;
    margin: 10px auto 100px;
  }

  .hod-kecheng_div {
    height: 100%;
  }

  .kecheng-but {
    width: 355px;
    height: 74px;
    background: #3C71FF;
    box-shadow: 0px 3px 30px 0px rgb(60 113 255 / 40%);
    border-radius: 15px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    margin-top: 54px;
    border: none;
  }

  .kecheng_box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
  }

  .kecheng_box_item {
    border-radius: 10px;
    background-color: #FFFFFF;
    padding: 8px;
    box-sizing: border-box;
    margin-bottom: 20px;
    width: 292px;
    cursor: pointer;
  }

  .kecheng_box_item img {
    width: 100%;
    height: 180px;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/Homes/popular.vue